import * as React from "react"
import { TestState } from "../utils/common"
import NSLocalizedString from "../utils/NSLocalizedString"
import { ConnectionTest, ConnectionTestGroup, groupStatus } from "./domutils"
import "./friendlies.css"
import { SubmitModal } from "./submitModal"

type TestProps = { tests: Array<ConnectionTest | ConnectionTestGroup> }

export class FriendlyTestBanner extends React.Component<TestProps> {

    render() {
        let stillGoing = this.props.tests.some(
            (e) => {
                if (e.hasOwnProperty('running') && (e as ConnectionTestGroup).running) {
                    return true
                }
                if (e.hasOwnProperty('status') && (e as ConnectionTest).status === TestState.InProgress) {
                    return true
                }
                return false
            })

        let header: React.ReactElement | string

        if (stillGoing) {
            header = NSLocalizedString("Checking network connectivity", "test banner");
        } else {
            let allGood = this.props.tests.every(
                (e) => {
                    let st: TestState
                    if (e.hasOwnProperty('status')) {
                        st = (e as ConnectionTest).status
                    } else {
                        st = groupStatus(e as ConnectionTestGroup)
                    }
                    return ( st === TestState.Ok || st === TestState.Uncertain )
                })

            if (allGood) {
                header = NSLocalizedString("Network test OK", "test banner");
            } else {
                header = NSLocalizedString("Network test unsuccessful", "test banner");
            }
        }

        return <div role="main" id="friendlybox"><h1 role="status" id="friendlybox-header">{header}</h1></div>
    }

}

export class RetestButton extends React.Component {
    retest = () => {
        window.location.reload(true);
    }

    render() {
        return (
            <button id="retest" onClick={this.retest}>{ NSLocalizedString("Retest", "button label") }</button>
        )
    }
}

export class SubmitReportButton extends React.Component<TestProps, { modalIsOpen: boolean }> {

    constructor(props: TestProps) {
        super(props)

        this.state = {
            modalIsOpen: false
        }
    }

    showSubmitModal = () => {
        this.setState({ modalIsOpen: true })
    }

    closeSubmitModal = () => {
        this.setState({ modalIsOpen: false })
    }

    render() {
        return (
            <div id="submit-container">
                <p>{ NSLocalizedString("If you are experiencing trouble, please contact our Support Humans:", "submit report action prompt") }</p>
                <button id="sendtoomni" onClick={this.showSubmitModal}>{ NSLocalizedString("Send Email", "submit report button label") }</button>
                <SubmitModal
                    tests={this.props.tests}
                    modalIsOpen={this.state.modalIsOpen}
                    closeModal={this.closeSubmitModal}
                />
            </div>
        )
    }

}
